import React, { PureComponent } from 'react';

// import i18n from '../../i18n';
// import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import styles from './LocalListPage.module.scss';
import PropTypes from 'prop-types';
import Hero from '../../components/Hero';
import StreamField from '../../components/StreamField';

class LocalListPage extends PureComponent {
    state = {};

    static defaultProps = {
        title: '',
    };

    static propTypes = {
        title: PropTypes.string.isRequired,
        contentBlocks: PropTypes.array,
    };

    render() {
        const { hero, contentBlocks } = this.props;
        return (
            <div className={styles['LocalListPage']}>
                <div className={styles['LocalListPage__Section--Black']}>
                    <Hero {...hero} />
                </div>

                {!!contentBlocks && <StreamField items={contentBlocks} />}
            </div>
        );
    }
}

export default basePageWrap(LocalListPage);
